import React, { type FC, useMemo } from 'react'

import type { ReadonlyPropsWithChildren } from '../utils'
import type { AbsoluteRoutePathWithAnyId } from './Domain'
import { ConnectwareRoutingProvider, useConnectwareRouting } from './Router.State'
import { mergeState } from './utils'

/**
 * Renders its children under the route state that navigating to the record would give them (its id, its relative routes, its parent),
 * without navigating: the URL and the route state of everything outside stay as they are
 *
 * Each record mounts afresh, rather than its predecessor's content getting the new id
 */
export const DetachedRoute: FC<ReadonlyPropsWithChildren<{ path: AbsoluteRoutePathWithAnyId, id: string }>> = ({ path, id, children }) => {
    const current = useConnectwareRouting()
    const state = useMemo(() => mergeState(current, path, id), [current, path, id])

    return (
        <ConnectwareRoutingProvider key={JSON.stringify(state)} value={state}>
            {children}
        </ConnectwareRoutingProvider>
    )
}
